import { Typography, Box } from "@mui/material";
// config

const CreatorBio = ({ bio }) => {
  if (!bio) return null;

  return (
    <Box>
      <Typography
        fontSize={12}
        fontWeight={400}
        lineHeight="16px"
        sx={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {bio}
      </Typography>
    </Box>
  );
};

export default CreatorBio;
